import React from 'react';
import { connect } from 'react-redux';
import './loader.css';
import TopBarProgress from "react-topbar-progress-indicator";
import { PrimaryColor } from '../../services/constants';
 
TopBarProgress.config({
  barColors: {
    "0": PrimaryColor,
    "1.0": PrimaryColor
  },
  shadowBlur: 5
});

const Loader = (props:any) => {
    return props.showLoader ?
        <TopBarProgress />
    // <div className="spinner">
    //     <div className="spinner-inner">
    //         <img src={'./assets/images/loader-image.gif'} alt="Loading..." />
    //     </div>
    // </div>
    :<></>
}


const mapStateToProps = (state: any) => ({
    showLoader: state.common.isLoading
})


export default connect(mapStateToProps,null)(Loader);